import { render } from "./Table.vue?vue&type=template&id=05018f05&scoped=true&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=05018f05&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05018f05"]])

export default __exports__